<template>
  <div class="wrap">
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_03/1488523536162.gif?imageView2/1/w/100/h/100" alt="">
        <h4>番剧</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="play-nav">
        <li>新番连载</li>
        <li>旧番补档</li>
        <li>过场动画</li>
        <li>动画资讯</li>
      </ul>
    </div>
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_03/1488523569142.gif" alt="">
        <h4>动画</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="animate-nav">
        <li>MAD·AMV</li>
        <li>MMD·3D</li>
        <li>2.5次元</li>
      </ul>
    </div>
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_03/1488523474487.gif" alt="">
        <h4>娱乐</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="disport-nav">
        <li>生活娱乐</li>
        <li>鬼畜调教</li>
        <li>萌宠</li>
        <li>美食</li>
        <li>综艺</li>
      </ul>
    </div>
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_03/1488523552005.gif" alt="">
        <h4>游戏</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="game-nav">
        <li>游戏集锦</li>
        <li>电子竞技</li>
        <li>主机单机</li>
        <li>英雄联盟</li>
        <li>守望先锋</li>
        <li>桌游卡牌</li>
        <li>Mugen</li>
      </ul>
    </div>
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_03/1488523586727.gif" alt="">
        <h4>音乐</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="music-nav">
        <li>原创·翻唱</li>
        <li>演奏</li>
        <li>Vocaloid</li>
        <li>日系音乐</li>
        <li>综合音乐</li>
        <li>演唱会</li>
      </ul>
    </div>
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_03/1488523606418.gif" alt="">
        <h4>舞蹈</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="dance-nav">
        <li>宅舞</li>
        <li>综合舞蹈</li>
        <li>爱豆</li>
        <li>手作</li>
        <li>造型</li>
      </ul>
    </div>
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_03/1488523679990.gif" alt="">
        <h4>科技</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="science-nav">
        <li>科学技术</li>
        <li>教程</li>
        <li>数码</li>
        <li>汽车</li>
        <li>广告</li>
      </ul>
    </div>
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_03/1488523695622.gif" alt="">
        <h4>体育</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="sport-nav">
        <li>综合体育</li>
        <li>足球</li>
        <li>篮球</li>
        <li>搏击</li>
        <li>11区体育</li>
        <li>惊奇体育</li>
      </ul>
    </div>
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_03/1488523660989.gif" alt="">
        <h4>鱼塘</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="pound-nav">
        <li>历史</li>
      </ul>
    </div>
    <div class="channel-nav">
      <div class="clearfix">
        <img src="http://imgs.aixifan.com/cms/2017_03_10/1489114940717.gif?imageView2/1/w/100/h/100" alt="">
        <h4>文章</h4>
        <span>更多<i class="fa fa-angle-right"></i></span>
      </div>
      <ul class="article-nav">
        <li>工作情感</li>
        <li>动漫文化</li>
        <li>漫画小说</li>
        <li>综合</li>
        <li>游戏</li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
      data() {
          return {

          }
      }
  }
</script>

<style lang="less" scoped>
  @import '../assets/css/channel.less';
</style>



// WEBPACK FOOTER //
// channel.vue?397633d2